<ul class="discounts">
  @for (discount of discountedPrices(); track discount.costBreakpoint; let i = $index) {
    <li class="discount-item">
      <div
        class="discount-price"
        [class.discount-price-active]="i === activeIndex()"
      >
        @if (isAggregator()) {
          <span class="discount-from">{{ 'global.from' | translate }}</span>
        }
        {{ discount.price }} <span class="discount-currency">{{ 'global.uah' | translate }}</span>
      </div>

      <div class="discount-info">
        <tc-icon
          class="discount-icon"
          name="cart"
        />
        <span class="discount-from">{{ 'global.from' | translate }}</span>
        <div class="discount-breakpoint">
          {{ discount.costBreakpoint }} {{ 'global.uah' | translate }}
        </div>
      </div>
    </li>
  }
</ul>
